/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReadNotificationCommand } from '../models/ReadNotificationCommand';
import type { ResponseData_Boolean } from '../models/ResponseData_Boolean';
import type { ResponseData_Int32 } from '../models/ResponseData_Int32';
import type { ResponseData_PagedResponse_NotificationResponse } from '../models/ResponseData_PagedResponse_NotificationResponse';
import type { SendNotificationCommand } from '../models/SendNotificationCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NotificationService {
    /**
     * Получить уведомления
     * @returns ResponseData_PagedResponse_NotificationResponse OK
     * @throws ApiError
     */
    public static getApiV1NotificationNotification({
        isRead,
        startAt,
        endAt,
        pageNumber,
        pageSize,
    }: {
        isRead?: boolean,
        startAt?: string,
        endAt?: string,
        pageNumber?: number,
        pageSize?: number,
    }): CancelablePromise<ResponseData_PagedResponse_NotificationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/notification/notification',
            query: {
                'isRead': isRead,
                'startAt': startAt,
                'endAt': endAt,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
        });
    }
    /**
     * Получить кол-во непрочитанных уведомлений
     * @returns ResponseData_Int32 OK
     * @throws ApiError
     */
    public static getApiV1NotificationNotificationUnreadCount(): CancelablePromise<ResponseData_Int32> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/notification/notification/unreadCount',
        });
    }
    /**
     * Прочитать уведомления
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1NotificationNotificationRead({
        requestBody,
    }: {
        requestBody?: ReadNotificationCommand,
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/notification/notification/read',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Отправить уведомление
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1NotificationNotificationSend({
        requestBody,
    }: {
        requestBody?: SendNotificationCommand,
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/notification/notification/send',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * SignalR Notification Hub — инструкция по использованию.
     *
     * Клиентам необходимо подключаться к SignalR-хабу по адресу:
     * `https://your-server.com/notificationHub`
     *
     * После установления соединения клиент должен в течение 5 сек вызвать метод:
     * ```
     * connection.invoke("AuthorizeConnection", token);
     *
     * ```
     * где `token` — пользовательский access token, выданный вашим API.
     * По истечении указанного временного интервала соединение будет разорвано.
     *
     *
     * После авторизации сервер может вызывать следующие методы на клиенте:<list type="bullet">
     * <item><description><b>ReceiveNotification(notification)</b> — получение уведомления.</description></item>
     * <item><description><b>ForceDisconnect(reason)</b> — сервер принудительно завершает соединение.</description></item></list>
     *
     * Рекомендуется на стороне клиента использовать SignalR с автоматическим переподключением:
     *
     * Пример клиента на TypeScript:
     *
     *
     * const connection = new signalR.HubConnectionBuilder()
     * .withUrl("https://your-server.com/notificationHub", {
         * transport: signalR.HttpTransportType.WebSockets,
         * skipNegotiation: true
         * })
         * .withAutomaticReconnect()
         * .build();
         *
         * await connection.start();
         * await connection.invoke("AuthorizeConnection", token);
         *
         * connection.on("ReceiveNotification", n => console.log("Notification:", n));
         * connection.on("ForceDisconnect", msg => connection.stop());
         *
         *
         * Подключение можно закрыть вызовом:```await connection.stop();```
         *
         * Этот эндпоинт не выполняет действий, служит только как документация для Swagger.
         * @returns any Описание успешно возвращено
         * @throws ApiError
         */
        public static getApiV1NotificationHubInfo(): CancelablePromise<any> {
            return __request(OpenAPI, {
                method: 'GET',
                url: '/api/v1/notification/hub-info',
            });
        }
    }
